
import SpamType from '@/enums/SpamType';

const MAX_REASON_LENGTH = 1000;
const TABS = ['article', 'brand_user'];

export default {
  name: 'SpamReportForm',
  emits: ['blocked-article-selected', 'change'],
  props: {
    initialTab: {
      type: String,
      default: 'article',
      validator: v => TABS.includes(v)
    },
    articleBlockedMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedTab: this.initialTab,
      selectedSpamType: SpamType.PLAGIARISM,
      reason: '',
      blocked: false
    };
  },
  computed: {
    SpamType() {
      return SpamType;
    },
    MAX_REASON_LENGTH() {
      return MAX_REASON_LENGTH;
    },
    tabs() {
      return TABS;
    },
    selectableSpamTypes() {
      return this.selectedTab === 'article'
        ? SpamType.articleSpamTypes
        : SpamType.brandUserSpamTypes;
    },
    formValues() {
      return {
        spam_report_target: this.selectedTab,
        spam_type: this.selectedSpamType,
        reason: this.reason,
        blocked: this.blocked
      };
    }
  },
  watch: {
    formValues: {
      immediate: true,
      handler(formValues) {
        this.$emit('change', formValues);
      }
    }
  },
  methods: {
    selectTab(tab) {
      if (tab === this.selectedTab) return;
      if (tab === 'article' && this.articleBlockedMessage) {
        this.$emit('blocked-article-selected', this.articleBlockedMessage);
        return;
      }

      this.selectedTab = tab;
      this.selectedSpamType = SpamType.PLAGIARISM;
      this.blocked = false;
    }
  }
};
